import { useLayoutEffect, type ReactNode } from 'react'

import { CHINA_FONT_FACES, isChinaEnvironment } from '../constants/chinaCdn'

import type { EnvironmentWithChina } from '../App'

export function ChinaCdnFonts({
  env,
  children,
}: {
  env: EnvironmentWithChina
  children?: ReactNode
}) {
  const isChina = isChinaEnvironment(env)

  useLayoutEffect(() => {
    if (!isChina) {
      return
    }

    document.documentElement.classList.add('customer-hub-cn')

    return () => {
      document.documentElement.classList.remove('customer-hub-cn')
    }
  }, [isChina])

  return (
    <>
      {isChina ? (
        <style dangerouslySetInnerHTML={{ __html: CHINA_FONT_FACES }} />
      ) : null}
      {children}
    </>
  )
}
